module.exports = __webpack_public_path__ + "img/care@2x.c6515e6.webp";